import type {ReactElement} from 'react';
import {AnimationLightbox} from '@Components/ai-chat-window/components/animation-lightbox/animation-lightbox';
import type {AiChatAnimation} from '@Components/ai-chat-window/components/assistant-message-image-part-animation-creations/assistant-message-image-part-animation-creations.types';
import {getUrlForAiChatAnimation, getUrlForAiChatAnimationThumbnail} from '@Libraries/ai-chat.library';
import {noop} from '@Utils/general.util';
import type {AiChatAssetsVideoPreviewProps} from './ai-chat-assets-video-preview.types';
import {VIDEO_PREVIEW_INDEX} from './ai-chat-assets-video-preview.types';

export function AiChatAssetsVideoPreview({asset, onClose}: AiChatAssetsVideoPreviewProps): ReactElement {
  const animation: AiChatAnimation = {
    animationHashedId: asset.assetHashedFilename,
    animationUrl: getUrlForAiChatAnimation(asset.assetHashedFilename),
    thumbnailUrl: getUrlForAiChatAnimationThumbnail(asset.assetHashedFilename),
    width: asset.width ?? 0,
    height: asset.height ?? 0,
    duration: asset.duration ?? 0,
    hasAudio: asset.hasAudio ?? false,
    model: '',
    startTime: asset.startTime ?? undefined,
    endTime: asset.endTime ?? undefined,
  };

  return (
    <AnimationLightbox
      isOpen
      onClose={onClose}
      animations={[animation]}
      currentIndex={VIDEO_PREVIEW_INDEX}
      onSelectAnimation={noop}
      onAnimationTrimmed={noop}
      chatId={asset.idAiChat}
      messageId={asset.messageId ?? undefined}
      hashedId={asset.assetHashedFilename}
      isWriteActionEnabled
      imageWidth={asset.width}
      imageHeight={asset.height}
    />
  );
}
